/**
 * PURPOSE: Consumir los contratos normalizados de circuitos acumulados desde Winscore.
 * RESPONSIBILITIES: Cargar editor/disponibilidad, guardar series y ejecutar recálculos seguros.
 * COLLABORATORS: CardCumulativeSeries.jsx, InstitucionesArea.jsx y backend cumulative-series.
 * ROUTE: winscore/src/services/cumulativeSeriesService.js
 */
import axios from "axios";
import API_BASE_URL from "../config/config.js";

const unwrap = (response) => response.data?.data || response.data;

export const getCumulativeSeriesEditor = async ({ idevent, idsport, seriesId }) => {
  const response = await axios.get(`${API_BASE_URL}/cumulative-series/editor`, {
    params: {
      idevent: Number(idevent),
      idsport: Number(idsport),
      ...(seriesId ? { seriesId: Number(seriesId) } : {}),
    },
  });
  return unwrap(response);
};

export const getCumulativeSeriesAvailability = async ({ idevent, idsport }) => {
  const response = await axios.get(
    `${API_BASE_URL}/cumulative-series/availability`,
    { params: { idevent: Number(idevent), idsport: Number(idsport) } }
  );
  return unwrap(response);
};

export const saveCumulativeSeries = async ({ seriesId, payload }) => {
  const url = seriesId
    ? `${API_BASE_URL}/cumulative-series/${seriesId}`
    : `${API_BASE_URL}/cumulative-series`;
  const response = seriesId
    ? await axios.patch(url, payload)
    : await axios.post(url, payload);
  return unwrap(response);
};

export const recalculateCumulativeSeries = async (seriesId) => {
  const response = await axios.patch(
    `${API_BASE_URL}/cumulative-series/${seriesId}/recalculate`
  );
  return unwrap(response);
};

export const recalculateCumulativeEvent = async ({ idevent, idsport, seriesId }) => {
  const response = await axios.patch(
    `${API_BASE_URL}/cumulative-series/recalculate-event`,
    {
      idevent: Number(idevent),
      idsport: Number(idsport),
      ...(seriesId ? { seriesId: Number(seriesId) } : {}),
    }
  );
  return unwrap(response);
};

